var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfinityScoreActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 3.75V26.25",
    stroke: "red",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 5.625H15.625L20 7.5H24.375C24.7065 7.5 25.0245 7.6317 25.2589 7.86612C25.4933 8.10054 25.625 8.41848 25.625 8.75V19.375C25.625 19.7065 25.4933 20.0245 25.2589 20.2589C25.0245 20.4933 24.7065 20.625 24.375 20.625H20L15.625 18.75H6.875V5.625Z",
    fill: "red",
    stroke: "red",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 26.25H9.375",
    stroke: "red",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfinityScoreActive);
export default __webpack_public_path__ + "static/media/afinityScoreActive.09eb14cdcc813befa4b519299ea590ba.svg";
export { ForwardRef as ReactComponent };